(function (angular) {
	angular.module('bizPartEngage').directive('bizEngageJourney', bizEngageJourneyDirective);
	angular.module('bizPartEngage').directive('bizEngageProgress', bizEngageProgressDirective);
	angular.module('bizPartEngage').directive('bizEngageProgressBar', bizEngageProgressBarDirective);
	angular.module('bizPartEngage').directive('bizEngageJourneyProgressBar', bizEngageJourneyProgressBarDirective);
    angular.module('bizPartEngage').directive('bizEngageProgressSettings', bizEngageProgressSettingsDirective);
    angular.module('bizPartEngage').directive('bizEngageStackedObjects', bizEngageStackedObjectsDirective);

	bizEngageJourneyDirective.$inject = ["bizCore"];
	bizEngageProgressDirective.$inject = ["bizCore"];
	bizEngageProgressBarDirective.$inject = ["bizCore"]
    bizEngageProgressSettingsDirective.$inject = ["bizCore"];
    bizEngageStackedObjectsDirective.$inject = ["bizCore"];   

    function bizEngageStackedObjectsDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
                engageObjects: '=',
                categoryId: '=',
                horizontal: '=?',
                gotoFunc: '&',
                bigImage: '=?'
            },
            templateUrl: bizCoreProvider.getView('core.directives.engagestackedobjects', "FrontEnd/Core/Directives/Views/EngageStackedObjects.html"),
            bindToController: true,
            controller: bizEngageStackedObjectsController,
            controllerAs: "vm",
        }

        bizEngageStackedObjectsController.$inject = ['$filter'];

        function bizEngageStackedObjectsController($filter) {
            var vm = this;

            vm.ImageList = [];

            vm.Init = Init;
            vm.SetSelected = SetSelected;
            vm.SetSelectedImageFirst = SetSelectedImageFirst;
            vm.Goto = Goto;

            function Goto() {
                vm.gotoFunc()(vm.Selected);
            }

            function SetSelected(obj) {
                vm.Selected = obj;
                vm.SetSelectedImageFirst();
            }

            function SetSelectedImageFirst() {                
                var index = 0;
                for (var i = 0; i < vm.ImageList.length; i++) {
                    if (vm.ImageList[i].Id === vm.Selected.Id) {
                        index = i;
                        break;
                    }
                }

                if (index === 0)
                    return;

                var first = vm.ImageList[index];
                var newList = [first];
                for (var i = 0; i < vm.ImageList.length; i++) {
                    if (i !== index) {
                        newList.push(vm.ImageList[i]);
                    }
                }
                vm.ImageList = newList;
            }

            function Init() {

                if (!vm.engageObjects || !vm.engageObjects.length)
                    return;
                
                var category;
                for (var i = 0; i < vm.engageObjects.length && !category; i++) {
                    category = vm.engageObjects[i].GenericCategories.GetItemByValue('Id', vm.categoryId);                    
                }

                if (!category)
                    return;

                for (var i = 0; i < vm.engageObjects.length; i++) {
                    var catObj = category.Objects.GetItemByValue('Id', vm.engageObjects[i].Id);
                    vm.engageObjects[i].Order = catObj.Order;
                }
    
                vm.engageObjects = $filter('orderBy')(vm.engageObjects, 'Order');

                vm.Selected = vm.engageObjects[0];                                            

                for (var i = 0; i < vm.engageObjects.length; i++) {                    
                    vm.ImageList.push(vm.engageObjects[i]);
                }
            }

            vm.$onInit = vm.Init;
        }

        return directive;
    }

	function bizEngageProgressBarDirective(bizCoreProvider) {
		var directive = {
			restrict: "E",
			scope: {
				label: '@',
                progress: '=',
                showProfileImage: '=?'
			},
			templateUrl: bizCoreProvider.getView('core.directives.engageprogressbar', "FrontEnd/Core/Directives/Views/EngageProgressBar.html"),
			bindToController: true,
			controller: bizEngageProgressBarController,
			controllerAs: "vm",
		}

		bizEngageProgressBarController.$inject = ['core.engage.service'];

		function bizEngageProgressBarController(engageService) {
			var vm = this;
		}

		return directive;
	}

	function bizEngageJourneyProgressBarDirective() {
		var directive = {
			restrict: "E",
			scope: {
				label: '@',
                showCustomJourney: '=?',//favorites not used atm
                showProfileImage: '=?'
			},
            template: '<biz-engage-progress-bar progress="vm.progress" label="{{vm.label}}" show-profile-image="vm.showProfileImage"></biz-engage-progress-bar>',
			bindToController: true,
			controller: bizEngageJourneyProgressBarController,
			controllerAs: "vm",
		}

		bizEngageJourneyProgressBarController.$inject = ['$rootScope', 'core.engage.service'];

		function bizEngageJourneyProgressBarController($rootScope, engageService) {
			var vm = this;
			vm.progress = 0;

			vm.Init = Init;

            function GetJourneys() {

                $rootScope.JourneysInitialized.then(InitJourneys);

                function InitJourneys() {
                    vm.Journeys = $rootScope.Journeys;

                    var objectCount = 0;
                    var finishedObjectCount = 0;
                    for (var i = 0; i < vm.Journeys.length; i++) {
                        for (var j = 0; j < vm.Journeys[i].EngageObjects.length; j++) {
                            objectCount++;
                            if (vm.Journeys[i].EngageObjects[j].Status === 3) {
                                finishedObjectCount++;
                            }
                        }
                    }                    

                    var progress = 0;
                    if (objectCount > 0) {
                        progress = Math.round((finishedObjectCount * 100) / objectCount);
                    }
                    vm.progress = progress;
                }				
			}

			function Init() {
				GetJourneys();

				//REGISTER FOR UPDATES
				if(vm.showCustomJourney) {
					$rootScope.$on('favorites.change', function() {
						GetJourneys();
					});
				}
			}

			vm.$onInit = vm.Init;
		}

		return directive;
	}

	function bizEngageProgressSettingsDirective(bizCoreProvider) {
		var directive = {
			restrict: "E",
			scope: {
				settingsHandler: '='
			},
			templateUrl: bizCoreProvider.getView('core.directives.engageprogresssettings', "FrontEnd/Core/Directives/Views/EngageProgressSettings.html"),
			bindToController: true,
			controller: bizEngageProgressSettingsController,
			controllerAs: "vm",
		}

		bizEngageProgressSettingsController.$inject = ['core.engage.service'];

		function bizEngageProgressSettingsController(engageService) {
			var vm = this;

			vm.Init = Init;
			vm.Save = Save;
			vm.GetSettings = GetSettings;

			function Init() {
				vm.settingsHandler = {
					Save: vm.Save
				};
				vm.GetSettings();
			}

			function GetSettings() {
				engageService.GetSettings().then(GetSettingsCallback);

				function GetSettingsCallback(response) {
					vm.Settings = response.data;
					vm.OriginalSettings = angular.copy(vm.Settings);
					vm.settingsHandler.Settings = vm.Settings;
				}
			}

			function Save() {
				vm.SavedSettings = true;
				engageService.SaveSettings(vm.Settings);
			}

			vm.$onDestroy = function () {
				if (!vm.SavedSettings)
					Object.assign(vm.Settings, vm.OriginalSettings);
			}

			vm.$onInit = vm.Init;
		}

		return directive;
	}

	function bizEngageProgressDirective(bizCoreProvider) {
		var directive = {
			restrict: "E",
			scope: {
				width: '@',
				data: '=?',
                settings: '=?',
                showProfileImage: '=?'
			},
			templateUrl: bizCoreProvider.getView('core.directives.engageprogress', "FrontEnd/Core/Directives/Views/EngageProgress.html"),
			bindToController: true,
			controller: bizEngageProgressController,
			controllerAs: "vm",
		}

        bizEngageProgressController.$inject = ['core.engage.service', '$scope', 'bizUser', '$rootScope'];

        function bizEngageProgressController(engageService, $scope, bizUser, $rootScope) {
			var vm = this;

            vm.Mascot = mascot;
            vm.BackgroundImage;

            vm.Init = Init;
            vm.SetProgress = SetProgress;
			//vm.GetEngageJourneys = GetEngageJourneys;

			//function GetEngageJourneys(useCache) {
			//	engageService.GetEngageJourneysForUser(!useCache).then(GetEngageJourneysCallback);

			//	function GetEngageJourneysCallback(journeys) {
   //                 vm.data = {};
   //                 console.log("journeys", journeys)

			//		if (journeys.Custom && journeys.Custom.length)
			//			vm.data.Custom = journeys.Custom[0].TotalProgress;

			//		if (journeys.General && journeys.General.length)
			//			vm.data.General = journeys.General[0].TotalProgress;
			//	}
   //         }    

            function SetProgress() {
                $rootScope.GetAllJourneysTotalProgress().then((progress) => {                    
                    vm.data = {};
                    vm.data.General = progress;
                });
            }

			function Init() {
                               

				if (!vm.settings) {

					vm.settings = {
						HideGeneralJourneyProgress: true,
						HideCustomJourneyProgress: true
					};
					
					engageService.GetSettings().then(GetSettingsCallback);
                }

                if (vm.showProfileImage) {
                    vm.LoggedInUser = bizUser.getLoggedInUser();
                    if (vm.LoggedInUser) {
                        vm.BackgroundImage = vm.LoggedInUser.Photo || 'Images/Common/no_user_photo.png';
                    }
                }

                if (!vm.BackgroundImage) {
                    vm.BackgroundImage = vm.Mascot.Image;
                }

				if (vm.data) return;

                vm.settings.HideCustomJourneyProgress = true;
                vm.SetProgress();
                
				//vm.GetEngageJourneys(true);

                $scope.$on('favorites.change', vm.SetProgress);
                $scope.$on('engageobject.finished', vm.SetProgress);

				function GetSettingsCallback(response) {
					vm.settings = response.data;
				}

				
			}

			vm.$onInit = vm.Init;
		}

		return directive;
	}

	function bizEngageJourneyDirective(bizCoreProvider) {
		var directive = {
			restrict: "E",
			scope: {
			},
			templateUrl: bizCoreProvider.getView('core.directives.engagejourney', "FrontEnd/Core/Directives/Views/EngageJourney.html"),
			bindToController: true,
			controller: bizEngageJourneyController,
			controllerAs: "vm"
		}

		bizEngageJourneyController.$inject = ['core.engage.service'];

		function bizEngageJourneyController(engageService) {
			var vm = this;

			vm.Init = Init;
			vm.GetEngageState = GetEngageState;

			function GetEngageState(engageObject) {
				switch (engageObject.EngageObjectType) {
					case 1:
						return "base.modules.html5education({id: " + engageObject.Id + "})";
						break;
					case 2:
						return engageObject.UrlRewrite ? "base.modules.blogtitle({title: '" + engageObject.UrlRewrite + "'})" : "base.modules.blog({id: " + engageObject.Id + "})";
						break;
					case 3:
						return "base.modules.mediafile({id: '" + (engageObject.UrlRewrite || engageObject.Id) + "'})";
						break;
				}
			}

			function Init() {
				engageService.GetEngageJourneys(false).then(GetJourneysCallback);

				function GetJourneysCallback(response) {
					vm.EngageJourneys = response.data;
				}
			}

			vm.$onInit = vm.Init;
		}

		return directive;
	}
})(window.angular);
